import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { useTranslation } from "react-i18next";
import { useGlobalState } from "../GlobalStates";

export const ShareProfileButton = ({ userId }) => {
  const { t } = useTranslation();
  const [_, setOpenAlertBannerMsg] = useGlobalState("openAlertBannerMsg");

  return (
    <CopyToClipboard text={`www.sotravel.com/profile/${userId}`}>
      <button
        className="tw-flex tw-flex-row tw-items-center tw-justify-center tw-bg-[rgb(239,239,239)] tw-text-black tw-py-[7px] tw-px-[18px] tw-rounded-[5px] tw-mx-[5px] tw-h-[2rem] tw-mt-[1rem] tw-text-[14px] tw-font-bold"
        onClick={() => {
          setOpenAlertBannerMsg(
            t("profile_link_copied", {
              defaultValue: "Profile link copied",
            })
          );
        }}
      >
        {t("share_profile", { defaultValue: "Share profile" })}
      </button>
    </CopyToClipboard>
  );
};

export default ShareProfileButton;
